// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12752":"0c154995","32622":"0c154995","49933":"be1e03da","58872":"0c154995","79931":"faebcb45","88056":"ae3ab8ec"}[chunkId] + ".chunk.css";
};